import { restClient } from '@/Core'
import type { Message } from '../Contracts'
import { mapApiMessage, type ApiMessage } from '../Helpers/apiMappers'

interface SendMessageParams {
    chatId: string
    content: string
    replyToId?: string
    /** Uuids of own pre-uploaded files (UploadChatFileTask) to attach */
    fileUuids?: string[]
}

/**
 * Sends a message: text, pre-uploaded attachments, or both (the backend
 * rejects a message with neither). The sender receives the created message
 * in this REST response; other participants get it via the `message:new`
 * realtime event (the backend deliberately does not echo it back to the sender).
 */
export const SendMessageTask = async ({ chatId, content, replyToId, fileUuids }: SendMessageParams): Promise<Message> => {
    const response = (await restClient.post(`/services/chat/chats/${chatId}/messages`, {
        json: {
            content,
            ...(replyToId ? { replyToUuid: replyToId } : {}),
            ...(fileUuids?.length ? { fileUuids } : {}),
        },
    })) as ApiMessage | null

    return mapApiMessage(response ?? {}, chatId)
}
